import * as React from "react";
const defaultClickAndReserveGlobalContextValues = {
  Form: void 0,
  confirmationNextSteps: void 0,
  opco: void 0,
  routes: {}
};
const clickAndReserveGlobalContext = React.createContext(
  defaultClickAndReserveGlobalContextValues
);
const useClickAndReserveGlobalContext = () => {
  const context = React.useContext(clickAndReserveGlobalContext);
  if (context === defaultClickAndReserveGlobalContextValues) {
    throw new Error(
      `No ClickAndReserveGlobalProvider available. You might still
      need to wrap the application with the ClickAndReserve form context Provider.`
    );
  }
  return context;
};
const ClickAndReserveGlobalProvider = ({
  Form,
  confirmationNextSteps,
  opco,
  routes,
  children
}) => {
  const { Provider } = clickAndReserveGlobalContext;
  const value = React.useMemo(
    () => ({
      Form,
      confirmationNextSteps,
      opco,
      routes
    }),
    [Form, confirmationNextSteps, opco, routes]
  );
  return /* @__PURE__ */ React.createElement(Provider, { value }, children);
};
clickAndReserveGlobalContext.displayName = "ClickAndReserveGlobalContext";
clickAndReserveGlobalContext.Consumer;
export {
  ClickAndReserveGlobalProvider,
  clickAndReserveGlobalContext,
  useClickAndReserveGlobalContext
};
//# sourceMappingURL=ClickAndReserveGlobalContext.js.map
